import React, { useEffect, useState } from 'react'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import { Avatar, Button, Skeleton } from '@mui/material'
import ItemsApp, { IItemModel } from './ItemsApp'
import NothingFound from '../../components/NothingFound'
import NewItemToContainer from './NewItemToContainer'
import { useDispatch } from 'react-redux'
import { handleRequestError } from '../../services/api'
import GenerateIcon from '../../components/GenerateIcon'
import { LoadingButton } from '@mui/lab'
import UnauthorizedBlock from '../../components/UnauthorizedBlock'

interface IProps {
    itemId: number,
    onlyShowItems?: boolean,
    usePublicDetails?: boolean
}

interface IContainerItemProps extends IItemModel {
    containerId: number,
    refresh: () => void,
    onlyShowItems?: boolean
}

export function ContainerItem(props: IContainerItemProps){

    const dispatch = useDispatch()

    const { id, title, thumbnail, unique_id, serial_number, quantity, containerId, refresh, onlyShowItems } = props

    const [loading, setLoading] = useState<boolean>(false)

    const itemsApp = new ItemsApp()

    /**
     * Remove
     */
    const remove = () => {
        setLoading(true)
        itemsApp.removeItemFromContainer(containerId, id)
            .then(response => {
                setLoading(false)
                refresh()
            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, dispatch)
            })
    }

    let enableRemove = true

    return(
        <div className="single-transcation-order">
            <div className="content-of-single-transcation-order">


                <div className="boxes-of-single-transcation-order">
                    <div className="content-of-boxes-of-single-transcation-order">

                        <div className="info-box-of-single-transcation-order" style={{ maxWidth: 50, minWidth: 50 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <Avatar src={thumbnail} style={{ width: 50, height: 50 }}>
                                    <GenerateIcon icon="image" />
                                </Avatar>
                            </div>
                        </div>

                        <div className="info-box-of-single-transcation-order" style={{ minWidth: 200, maxWidth: 200 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Item:</h3>
                                <p><a href={`/panel/items/view/${unique_id}`}>{title}</a></p>
                            </div>
                        </div>

                        <div className="info-box-of-single-transcation-order" style={{ minWidth: 200, maxWidth: 200 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Unique ID:</h3>
                                <p>{unique_id}</p>
                            </div>
                        </div>

                        <div className="info-box-of-single-transcation-order" style={{ minWidth: 200, maxWidth: 200 }}>
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Serial Number:</h3>
                                <p>{serial_number ? serial_number : "-"}</p>
                            </div>
                        </div>

                        <div className="info-box-of-single-transcation-order">
                            <div className="content-of-info-box-of-single-transcation-order">
                                <h3>Quantity</h3>
                                <p>{quantity}</p>
                            </div>
                        </div>

                    </div>
                </div>

                {!onlyShowItems && (
                    <div className="buttons-of-single-transcation-order">
                        <div className="content-of-buttons-of-single-transcation-order">
                            
                            <LoadingButton disabled={enableRemove ? false : true} loading={loading} style={{ height: 45 }} className="general-button" color="error" variant="text" onClick={() => remove()}>Remove</LoadingButton>

                        </div>
                    </div>
                )}

            </div>
        </div>
    )
}

export default function ContainerItems(props: IProps) {

    const dispatch = useDispatch()

    const { itemId, onlyShowItems, usePublicDetails } = props

    const [loading, setLoading] = useState<boolean>(true)
    const [items, setItems] = useState<IItemModel[]>([])

    const itemsApp = new ItemsApp()

    const [modalOpen, setModalOpen] = useState<boolean>(false)

    /**
     * Render loading items
     */
    const renderLoadingItems = () => {
        return(
            <>
                <Skeleton variant="rectangular" width="100%" height={100} style={{ marginBottom: 10 }}/>
                <Skeleton variant="rectangular" width="100%" height={100} style={{ marginBottom: 10 }} />
                <Skeleton variant="rectangular" width="100%" height={100} style={{ marginBottom: 10 }} />
                <Skeleton variant="rectangular" width="100%" height={100} style={{ marginBottom: 10 }} />
                <Skeleton variant="rectangular" width="100%" height={100} style={{ marginBottom: 10 }} />
            </>
        )
    }

    /**
     * Add new items
     */
    const addNewItem = () => handleOpenModal()

    /**
     * Load items
     */
    const loadItems = () => {
        setLoading(true)

        itemsApp.returnContainerItemList(itemId)
            .then(response => {
                setLoading(false)
                setItems(response.data)
            })
            .catch(error => {
                setLoading(false)
                handleRequestError(error, dispatch)
            })


    }

    /**
     * Render items
     */
    const renderItems = () => {

        if (usePublicDetails){
            return <UnauthorizedBlock title="Unauthorized" message="You have to sign-in to your account in order to view the information." buttons={[ { label: "Sign-in", link: "/sign-in", color: "error" } ]} />
        }

        if (loading){
            return renderLoadingItems()
        }

        if (items.length === 0){
            return <NothingFound title="Nothing found.." message="You haven't added any items to this container yet" />
        }

        return items.map((item, index: number) => <ContainerItem {...item} key={index} containerId={itemId} refresh={loadItems} onlyShowItems={onlyShowItems} />)
    }

    /**
     * Handle open modal
     */
    const handleOpenModal = () => setModalOpen(true)

    /**
     * Handle close modal
     */
    const handleCloseModal = () => setModalOpen(false)

    /**
     * Load items
     */
    useEffect(() => {
        if (!usePublicDetails){
            loadItems()
        }
    }, [itemId])

    if (onlyShowItems){
        return <>{renderItems()}</>
    }

    return(
        <SectionBoxContainer
            showTitle
            title="Container Items"
            description="This container contains following items:"
        >

            <NewItemToContainer open={modalOpen} handleClose={handleCloseModal} itemId={itemId} refreshItems={loadItems} />

            <div className="all-item-inventory-locations-container">
                <div className="content-of-all-item-inventory-locations-container">
                    {renderItems()}
                </div>
            </div>

            {!usePublicDetails && (
                <div className="action-buttons-of-section-box-admin-panel container-items">
                    <div className="content-of-action-buttons-of-section-box-admin-panel">

                        <Button className="general-button admin-style light-button" color="info" variant="text" onClick={() => loadItems()}>Refresh</Button>
                        <Button className="general-button admin-style light-button" color="success" variant="contained" onClick={() => addNewItem()}>Add item</Button>

                    </div>
                </div>
            )}
            
        </SectionBoxContainer>
    )
}